import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import Shepherd from 'shepherd.js';
import { ShepherdService } from 'angular-shepherd';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { MapHelperService } from 'src/services/map-helper.service';
import { EstatusJSON } from '../../../../shared/models/EstatusJSON';
import { mainSteps, panelLocationSteps, panelDetailLocationSteps, panelRouteControlSteps, panelRouteResumeSteps, panelGeofencesSteps, panelGeofenceDetailSteps, panelAddGeofence } from '../home.tour.config';
import { LocalStorageService } from '../../../../shared/services/LocalStorage.service';
import { SessionService } from 'src/app/features/shared/services/Session.service';

@Injectable({
  providedIn: 'root',
})
export class TutorialService {
  private tours: { [key: string]: Shepherd.Tour } = {};
  private isActiveTour: boolean = false;
  private configUrl: string;
  subscription_SetTutorial: Subscription;

  constructor(
    private http: HttpClient,
   private mapHelperService: MapHelperService,
   private localStorageService: LocalStorageService,
   private sessionService: SessionService
  ){
    this.configUrl = environment.host;
  }


  setupTours(): void {
    this.createTour('mainTutorial', mainSteps);
    this.createTour('panelLocationTutorial', panelLocationSteps);
    this.createTour('panelDetailLocationTutorial', panelDetailLocationSteps);
    this.createTour('panelRouteControlTutorial', panelRouteControlSteps);
    this.createTour('panelRouteResumeTutorial', panelRouteResumeSteps);
    this.createTour('panelGeofencesTutorial', panelGeofencesSteps);
    this.createTour('panelGeofenceDetailTutorial', panelGeofenceDetailSteps);
    this.createTour('panelAddGeofenceTutorial', panelAddGeofence);
  }

  createTour(name: string, steps: Shepherd.Step.StepOptions[]): void {
    const tour = new Shepherd.Tour({
      defaultStepOptions: {
        scrollTo: true,
      },
      useModalOverlay: true,
    });

    steps.forEach((step) => {
      tour.addStep(step);
    });

    this.tours[name] = tour;
  }

  startTutorial(names: string[]): void {
    if(!this.sessionService.isMapix || this.sessionService.isExternalMap.value)
      return;
    if(!environment.production) console.log('Starting tutorial', names, this.tours[names[0]], this.tours), this.localStorageService.getShownTutorials();
    const shownTutorials = JSON.parse(this.localStorageService.getShownTutorials());
    
    names.forEach((name) => {
      if (!this.isActiveTour) {
        //verifica si ya se mostró el tutorial
        if (shownTutorials.includes(name)) {
          if(!environment.production) console.log('Tutorial ya nostrado ', name);
          return;
        }

        if (this.tours[name]) {
            this.tours[name].start();
            this.isActiveTour = true;
            // Escuchar cuando el tour finaliza correctamente (completo)
            this.tours[name].on('complete', () => {
              this.isActiveTour = false;
              this.subscription_SetTutorial = this.SetTutorialShown(name).subscribe({
                next: (res) => {
                  if(!environment.production) console.log('Tutorial mostrado', res);
                  if (res.isSuccess) {
                    shownTutorials.push(name);
                    this.localStorageService.setShownTutorials(JSON.stringify(shownTutorials));
                  } else {
                    Sentry.captureMessage('TutorialService.SetTutorialShown (complete): isSuccess false', { level: 'warning', extra: { response: res } });
                  }
                  this.subscription_SetTutorial.unsubscribe();
                },
                error: (error) => {
                  // TODO marca para complete despues
                  console.error('Error al guardar tutorial', error);
                  this.subscription_SetTutorial.unsubscribe();
                }
              });
              // if (name === 'mainTutorial')
              //   this.mapHelperService.startTour();
            });
            
            // Escuchar cuando el tour se cancela
            this.tours[name].on('cancel', () => {
              this.isActiveTour = false;
              this.subscription_SetTutorial = this.SetTutorialShown(name).subscribe({
                next: (res) => {
                  if(!environment.production) console.log('Tutorial mostrado', res);
                  if (res.isSuccess) {
                    shownTutorials.push(name);
                    this.localStorageService.setShownTutorials(JSON.stringify(shownTutorials));
                  } else {
                    Sentry.captureMessage('TutorialService.SetTutorialShown (cancel): isSuccess false', { level: 'warning', extra: { response: res } });
                  }
                  this.subscription_SetTutorial.unsubscribe();
                },
                error: (error) => {
                  // TODO marca para complete despues
                  console.error('Error al guardar tutorial mostrado (cancelado)', error);
                  this.subscription_SetTutorial.unsubscribe();
                }
              });
              // if (name === 'mainTutorial')
              //   this.mapHelperService.startTour();
            });
        } else {
          console.error(`El tutorial ${name} no existe.`);
        }
    }
    });
  }

  SetTutorialShown( tutorialName: string){
    return this.http.get<EstatusJSON>(this.configUrl + "/api/UserTutorial/Insert?tutorialName="+tutorialName)
  }
  
  GetShownTutorials(){
    return this.http.get<EstatusJSON>(this.configUrl + "/api/UserTutorial/GetNamesListByUserId")
  }

  
}